import { defineComponent as N, useAttrs as P, provide as b, ref as i, computed as r, useId as M, watch as T, createElementBlock as I, createCommentVNode as $, openBlock as v, mergeProps as B, renderSlot as O, createVNode as W, normalizeClass as x, unref as G, withCtx as V, createBlock as H, resolveDynamicComponent as K, normalizeProps as L, guardReactiveProps as U, h as j } from "vue";
import q from "./CdrFilmstripEngine.vue.mjs";
import { useDebounceFn as J, useResizeObserver as Q } from "@vueuse/core";
import { CdrFilmstripEventKey as X } from "../../types/symbols.mjs";
const Y = 6, oe = /* @__PURE__ */ N({
  name: "CdrFilmstrip",
  __name: "CdrFilmstrip",
  props: {
    adapter: {
      type: Function,
      default: () => (m) => (console.warn("No adapter provided for CdrFilmstrip"), {
        frames: [],
        filmstripId: "empty-filmstrip",
        component: j("div"),
        description: "An empty filmstrip"
      })
    },
    model: {
      default: () => ({})
    }
  },
  emits: ["arrowClick", "scrollNavigate", "resize", "ariaMessage"],
  setup(m, {
    emit: y
  }) {
    var p, f;
    const s = m, n = y, h = (e, a) => {
      n(e, a);
    }, w = P().class || "";
    b(X, h);
    const u = i(null), t = r(() => s.adapter(s.model)), l = i(((p = t == null ? void 0 : t.value) == null ? void 0 : p.framesToShow) ?? Y), c = i(l.value), d = r(() => t.value.frames), F = r(() => d.value.length > 0), S = r(() => `${t.value.filmstripId}-${M()}`), z = r(() => t.value.description), C = r(() => {
      var e;
      return ((e = t == null ? void 0 : t.value) == null ? void 0 : e.framesGap) || 0;
    }), g = i(typeof ((f = t == null ? void 0 : t.value) == null ? void 0 : f.useDefaultResizeStrategy) == "boolean" ? t.value.useDefaultResizeStrategy : !1), k = r(() => {
      var e;
      return ((e = t == null ? void 0 : t.value) == null ? void 0 : e.focusSelector) || ":first-child";
    }), A = r(() => {
      var e;
      return ((e = t.value) == null ? void 0 : e.dataAttributes) || {};
    });
    function R({
      event: e,
      direction: a
    }) {
      const o = {
        event: e,
        direction: a,
        model: s.model
      };
      n("arrowClick", o);
    }
    function _({
      index: e,
      event: a
    }) {
      const o = {
        event: a,
        index: e,
        model: s.model
      };
      n("scrollNavigate", o);
    }
    function D() {
      const e = window.innerWidth;
      l.value = e >= 1024 ? 5 : e >= 768 ? 4 : 2, c.value = Math.max(l.value - 1, 1);
    }
    const E = J(() => {
      const e = {
        model: s.model,
        framesToShow: l,
        framesToScroll: c
      };
      n("resize", e), g.value && D();
    }, 25);
    return T(() => u.value, (e) => {
      e && Q(e, E);
    }, {
      immediate: !0
    }), (e, a) => F.value ? (v(), I("div", B({
      key: 0,
      ref_key: "CdrFilmstripContainer",
      ref: u
    }, A.value), [O(e.$slots, "heading"), W(q, {
      class: x(G(w)),
      id: S.value,
      description: z.value,
      frames: d.value,
      "frames-gap": C.value,
      "frames-to-show": l.value,
      "frames-to-scroll": c.value,
      "focus-selector": k.value,
      onAriaMessage: a[0] || (a[0] = (o) => e.$emit("ariaMessage", o)),
      onArrowClick: R,
      onScrollNavigate: _
    }, {
      frame: V(({
        ...o
      }) => [(v(), H(K(t.value.component), L(U(o)), null, 16))]),
      _: 1
    }, 8, ["class", "id", "description", "frames", "frames-gap", "frames-to-show", "frames-to-scroll", "focus-selector"])], 16)) : $("", !0);
  }
});
export {
  oe as default
};
